import request from '@/util/request'

// 交易项目分页列表（需求）
export function getNeedProjectList (params) {
    return request({
        method: 'post',
        data: params,
        url: '/api/needProjectList'
    })
}

// 交易项目详情（需求）
export function getNeedProjectDetail (params) {
    return request({
        method: 'post',
        params,
        url: '/api/needProDetail'
    })
}

// 新增招投标报名
// export function addInvitation(data) {
//     request({
//         method: 'post',
//         url: '/transfer/auctionApply/addInvitation',
//         data
//     })
// }